/**
 * Llama RPC URLs + wagmi transports.
 * Primary RPC is always rpc.llama-rpc.com, with public fallbacks.
 */

import { fallback, http } from "wagmi";

const getLlamaRpc = (chain: string) => `https://rpc.llama-rpc.com/${chain}?source=llamaswap`;

/** Chain ID → ordered array of RPC URLs (Llama RPC first, then public fallbacks) */
export const rpcUrls: Record<number, string[]> = {
  1: [getLlamaRpc("ethereum"), "https://cloudflare-eth.com", "https://ethereum.publicnode.com"],
  10: [
    getLlamaRpc("optimism"),
    "https://mainnet.optimism.io",
    "https://optimism-mainnet.public.blastapi.io",
  ],
  25: [getLlamaRpc("cronos"), "https://evm.cronos.org"],
  56: [getLlamaRpc("bsc"), "https://bsc-dataseed.binance.org", "https://bsc-dataseed1.defibit.io"],
  100: [getLlamaRpc("xdai"), "https://rpc.gnosischain.com"],
  130: [getLlamaRpc("unichain"), "https://unichain-rpc.publicnode.com"],
  137: [
    getLlamaRpc("polygon"),
    "https://polygon-rpc.com",
    "https://polygon-bor-rpc.publicnode.com",
  ],
  143: [getLlamaRpc("monad"), "https://rpc.monad.xyz"],
  146: [getLlamaRpc("sonic"), "https://rpc.soniclabs.com"],
  250: [getLlamaRpc("fantom"), "https://rpcapi.fantom.network"],
  288: [getLlamaRpc("boba"), "https://mainnet.boba.network"],
  324: [getLlamaRpc("era"), "https://mainnet.era.zksync.io"],
  480: [getLlamaRpc("worldchain")],
  999: [getLlamaRpc("hyperliquid"), "https://rpc.hyperliquid.xyz/evm"],
  1088: [getLlamaRpc("metis")],
  1101: [getLlamaRpc("polygon_zkevm"), "https://zkevm-rpc.com"],
  1284: [getLlamaRpc("moonbeam"), "https://rpc.api.moonbeam.network"],
  1285: [getLlamaRpc("moonriver"), "https://rpc.api.moonriver.moonbeam.network"],
  2222: [getLlamaRpc("kava")],
  4326: [getLlamaRpc("megaeth")],
  8217: [getLlamaRpc("klaytn"), "https://public-node-api.klaytnapi.com/v1/cypress"],
  8453: [getLlamaRpc("base"), "https://mainnet.base.org", "https://base-rpc.publicnode.com"],
  9745: [getLlamaRpc("plasma")],
  42161: [
    getLlamaRpc("arbitrum"),
    "https://arb1.arbitrum.io/rpc",
    "https://arbitrum-one.public.blastapi.io",
  ],
  42220: [getLlamaRpc("celo"), "https://forno.celo.org"],
  43114: [getLlamaRpc("avax"), "https://api.avax.network/ext/bc/C/rpc"],
  57073: [getLlamaRpc("ink")],
  59144: [getLlamaRpc("linea"), "https://rpc.linea.build"],
  80094: [getLlamaRpc("berachain")],
  534352: [getLlamaRpc("scroll"), "https://rpc.scroll.io"],
  1313161554: [getLlamaRpc("aurora")],
};

/** wagmi fallback transports — tries Llama RPC first, then public RPCs */
export const rpcsTransports: Record<number, ReturnType<typeof fallback>> = Object.fromEntries(
  Object.entries(rpcUrls).map(([chainId, urls]) => [
    Number(chainId),
    fallback([...new Set(urls)].map((rpc) => http(rpc, { timeout: 3_000 }))),
  ]),
);
